/*
 * @Author: linwl 1015547748@qq.com
 * @Date: 2021-07-21 11:10:46
 * @LastEditors: linwl 1015547748@qq.com
 * @LastEditTime: 2025-08-27 09:37:36
 * @FilePath: \newmall\src\router\routes\tabbarRoute.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import config from '@/config/config'
import TabbarLayout from '@/layout/TabbarLayout/index.vue'

/*
  tabShow 是否展示底部导航
  keepAlive 是否需要缓存组件
  noLogin 页面是否开启免登录
	showScrollTop 是否展示 BaseLayout 的回到顶部按钮，默认展示，
	             显式声明 false 才隐藏（表单页、短页面、自带滚动容器的页面）
  locationMode 定位模式：wait 等待定位完成；background 后台定位，不阻塞页面进入
*/

const visitorMode = Boolean(
  process.env.VUE_APP_VISITOR_MODE
)

const tabbar = [
  {
    path: '/tabbar',
    name: 'Tabbar',
    component: TabbarLayout,
    meta: {
      showBackBtn: false,
      showScrollTop: true,
      keepAlive: true
    },
    children: [
      {
        path: '/tabbar/home',
        name: 'Home',
        component: () => import('@/views/Home'),
        meta: {
          name: '首页',
          keepAlive: true,
          noLogin: config.visitorMode,
          routerBack: false,
          showScrollTop: true,
          icon: 'home',
          showBackBtn: false,
          // 首页优先展示首屏，定位在后台执行，不阻塞页面进入
          locationMode: 'background'
        }
      },
      {
        path: '/tabbar/category',
        name: 'Category',
        component: () => import('@/views/category'),
        meta: {
          name: '分类',
          keepAlive: true,
          noLogin: config.visitorMode,
          routerBack: false,
          icon: 'category',
          showBackBtn: false,
          showScrollTop: true,
          locationMode: 'wait'
        }
      },
      {
        path: '/tabbar/car',
        name: 'Cart',
        component: () => import('@/views/cart'),
        meta: {
          name: '购物车',
          tabShow: true,
          keepAlive: true,
          routerBack: false,
          icon: 'cart',
          showBackBtn: false,
          showScrollTop: true,
          locationMode: 'wait'
        }
      },
      {
        path: '/tabbar/my',
        name: 'My',
        component: () => import('@/views/my'),
        meta: {
          name: '我的',
          tabShow: true,
          routerBack: false,
          icon: 'my',
          showBackBtn: false,
          showScrollTop: true
        }
      }
    ]
  }
]

export default tabbar
